<template>
    <div class="fixed bottom-0 right-0 z-50 mb-5 mr-5">
        <transition-group name="slide">
            <div
                v-for="alert in alerts"
                :key="alert.text"
                class="flex items-center p-6 mt-4 bg-white border-l-8 border-yellow-500 shadow-strong"
                style="width: 280px;"
            >
                <p :class="{ 'text-red-500': alert.type === 'error' }">{{ alert.text }}</p>
            </div>
        </transition-group>
    </div>
</template>

<script>
export default {
    props: {
        alerts: {
            type: Array,
            required: true
        }
    }
};
</script>
